import React, { useEffect, useState } from "react";
import {
  FloatButton,
  Drawer,
  Select,
  DatePicker,
  Button,
  Skeleton,
} from "antd";
import { SearchOutlined, SettingOutlined } from "@ant-design/icons";
import SteamGaugeCard from "./SteamGaugeCard";
// import errorNew from "../../../assets/error/error.png";
import SteamMeters from "./SteamMeters";
import SteamGaugeChart from "./SteamGaugeChart";
import { calculateDateRangeFromDate } from "../../../../../Utils/DateConverstion";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../Common/APIConstants";

const SteamConvertorStatus = () => {
  const {loading, makeRequest } = useStoreUpdaterWithAPI();
  const [open, setOpen] = useState(false);
  const [skip, setSkip] = useState(true);
  const [treeChartInput, setTreeChartInput] = useState("");
  const [meterData, setMeterData] = useState([]);
  // TVSDashBoard/ConverterStaus?FromDate=2023-10-27%207%3A15%3A00.000&ToDate=2023-10-28%207%3A25%3A00.000

  // const urll = `${APIConstants.GET_STEAM_DASHBOARD_CONVERTOR_STATUS}?FromDate=${treeChartInput.FromDate}&ToDate=${treeChartInput.ToDate}`;
  // console.log(urll)
  // useState(()=>{
  //   const urll = `${APIConstants.GET_STEAM_DASHBOARD_CONVERTOR_STATUS}?FromDate=${treeChartInput.FromDate}&ToDate=${treeChartInput.ToDate}`;
  // console.log(urll)
  //     if(treeChartInput) (

  //         makeRequest({
  //             type: APIConstants.GET,
  //             url : `${APIConstants.GET_STEAM_DASHBOARD_CONVERTOR_STATUS}?FromDate=${treeChartInput.FromDate}&ToDate=${treeChartInput.ToDate}`

  //           }).then((res) => {
  //             setMeterData(res);
  //             console.log(res);
  //           })
  //     )  

  // },[treeChartInput]);

  const fetchConvertorStatus = (input) => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_STEAM_DASHBOARD_CONVERTOR_STATUS}?FromDate=${input.FromDate}&ToDate=${input.ToDate}`,
    }).then((res) => {
      setMeterData(res);
      console.log(res);
    });
  };

  useEffect(() => {
    if (treeChartInput) {
      fetchConvertorStatus(treeChartInput);
    }
  }, [treeChartInput]);

  const setTreeChartInputString = () => { 
    // try {

    const currentDate = new Date();
    const { from, to } = calculateDateRangeFromDate(currentDate, 5, 1);
    const treeChartInputData = {
      FromDate: from,
      ToDate: to,
    };
    console.log(treeChartInputData);

    const finalInput = treeChartInputData;
    setTreeChartInput(finalInput);

    // }catch{()
    //     // console.log(e)
    // }
  };

  useEffect(() => {
    setTreeChartInputString();
  }, []);

  return (
    <div>
      <div className="flex justify-center">
        {loading  && (
        <>
          <Skeleton active paragraph={{ rows: 6 }} />
        </>
        )}
        {
          //   isError && (
          // <div className="flex flex-col">
          //   <img className="w-[150px] h-[80px] "  />
          //   <p className="text-sm text-red-500 text-center">Server error</p>
          //   <p className="text-center">Please reload the page</p>
          // </div>
          //   )
        }
      </div>
      {meterData && (
        <div className="flex flex-wrap gap-0">
          {meterData.map((item, index) => (
            <SteamMeters key={index} item={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SteamConvertorStatus;
